<template>
  <div class="container">
    <div class="filter-content">
      <div class="filter-list">
        <div class="filter-item flex">
          <span class="filter-label">项目类型:</span>
          <ul class="flex filter-option-list">
            <li
              v-for="(item, index) in projectTypeList"
              :key="index"
              class="filter-option"
              :class="{ active: item.code === activeType }"
              @click="selectFilter('businessType', item.code)"
            >
              {{ item.name }}
            </li>
            <li
              v-for="(item, index) in systemTypeList"
              :key="item.code"
              class="filter-option"
              :class="{ active: item.code === activeType }"
              @click="selectFilter('systemType', item.code)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
        <div v-if="showStatus && tableType == 1" class="filter-item flex">
          <span class="filter-label">项目状态:</span>
          <ul class="flex filter-option-list">
            <li
              v-for="(item, index) in statusList"
              :key="index"
              class="filter-option"
              :class="{ active: item.code === searchForm.status }"
              @click="selectFilter('status', item.code)"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
      </div>
      <div class="filter-total clearfix select-list-bot">
        <span class="color-666 fl">
          当前记录
          <em class="color-theme-red">{{ total }}</em>
          条
        </span>
        <!-- <span class="fl">
                <span class="fl ml-10">价格：</span>
                <div class="boxTop">
                  <input id="startPrice" class="ip1 fl" type="text" placeholder="¥" value="" style="height:25px;width:55px" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')">
                  <span class="fl">−</span>
                  <input id="endPrice" value="" class="ip2 fl" type="text" placeholder="¥" style="height:25px;width:55px;" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')">
                  <a class="fl money-btn" onclick="pageList(1)">确定</a>
                </div>
        </span> -->
        <div v-if="tableType == 1" class="fr">
          默认排序&nbsp;&nbsp;
          <a
            id="type1"
            class="location"
            @click="handleSortChange('orderType1')"
          >
            默认
          </a>
          <a
            id="type2"
            class="location"
            :class="{
              up: searchForm.orderType === 'orderType2_up',
              down: searchForm.orderType === 'orderType2_down',
            }"
            @click="handleSortChange('orderType2')"
          >
            低价 <em class="icon-jiage" />
          </a>
          <a
            id="type3"
            class="location"
            :class="{
              up: searchForm.orderType === 'orderType3_up',
              down: searchForm.orderType === 'orderType3_down',
            }"
            @click="handleSortChange('orderType3')"
          >
            最新 <em class="icon-jiage" />
          </a>
        </div>
      </div>
    </div>

    <div v-if="tableType == 1" style="margin-top: 20px">
      <div v-if="list.length || loading" v-loading="loading">
        <product-list :list="list" />
      </div>
      <div v-else style="height: 450px">
        <no-data />
      </div>
      <el-pagination
        class="table-pagination flex-center"
        hide-on-single-page
        background
        :current-page="curPage"
        :page-size="16"
        :pager-count="5"
        prev-text="上一页"
        next-text="下一页"
        layout=" prev, pager, next, slot"
        :total="total"
        @current-change="handleCurrentChange"
      >
        <div class="flex align-center color-666">
          <div>共{{ curPage }}页/共{{ total }}条数据</div>
          <div class="flex-center ml-20">
            <p>转到</p>
            <el-input-number
              v-model="curSdPage"
              class="page-input"
              :controls="false"
              :min="1"
              :max="maxPage"
              :step="1"
              step-strictly
            />
            <p class="ml-5">页</p>
            <el-button class="jump-btn" @click="handleCurrentChange(curSdPage)">
              确定
            </el-button>
          </div>
        </div>
      </el-pagination>
    </div>
    <div v-else class="list-content">
      <el-table
        v-if="list.length || loading"
        ref="projectTableRef"
        v-loading="loading"
        class="project-table"
        :data="list"
        fit
        :default-sort="{ prop: 'endTime', order: null }"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @sort-change="handleSortChange"
        @row-click="rowClick"
      >
        <el-table-column label="项目名称" min-width="180" header-align="center">
          <template slot-scope="{ row }">
            <div class="text-cut" :title="row.title">
              {{ row.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="fbstartDate"
          label="发布时间"
          width="350"
          align="center"
        />
      </el-table>
      <div v-else style="height: 450px">
        <no-data />
      </div>

      <el-pagination
        class="table-pagination flex-center"
        hide-on-single-page
        background
        :current-page="curPage"
        :page-size="pageSize"
        :pager-count="5"
        prev-text="上一页"
        next-text="下一页"
        layout=" prev, pager, next, slot"
        :total="total"
        @current-change="handleCurrentChange"
      >
        <div class="flex align-center color-666">
          <div>共{{ curPage }}页/共{{ total }}条数据</div>
          <div class="flex-center ml-20">
            <p>转到</p>
            <el-input-number
              v-model="curSdPage"
              class="page-input"
              :controls="false"
              :min="1"
              :max="maxPage"
              :step="1"
              step-strictly
            />
            <p class="ml-5">页</p>
            <el-button
              class="jump-btn"
              @click="handleCurrentChange(curSdPage)"
            >确定</el-button>
          </div>
        </div>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import porpertyApi from "@/api/porperty";
import noticeApi from "@/api/newnotice";
import dictApi from "@/api/dict";
import { parseTime } from "@/filters";
import {
  INFO_TYPE_OPTIONS3,
  INFO_TYPE_OPTIONS,
  PROJECT_STATUS_OPTIONS2,
  ORGANIZATION_OPTIONS,
  getConstantDic,
  UNIT_TYPE,
  SELECT_OPTION_CONFIG
} from "@/utils/constant";
import NoData from "@/components/NoData.vue";
import { mapActions, mapGetters } from "vuex";
import productList from "./components/productList.vue";
export default {
  name: "ProjectList",
  components: {
    NoData,
    productList
  },
  props: {},
  data() {
    return {
      path: "",
      // 项目板块
      unitType: getConstantDic(UNIT_TYPE),
      // 项目类型  工程：GC 货物：HW 服务：FW 其他：QT）
      projectTypeList: "",
      // 公告类型
      noticeTypeList: getConstantDic(INFO_TYPE_OPTIONS),
      // 项目所在地
      projectAreaList: [],
      // 区县
      districtList: [],
      // 项目状态
      statusList: getConstantDic(PROJECT_STATUS_OPTIONS2),
      // 组织单位
      fbDwGuidList: getConstantDic(ORGANIZATION_OPTIONS),
      systemTypeList: getConstantDic(INFO_TYPE_OPTIONS3),
      searchForm: {
        title: "",
        unitType: "",
        projectType: "",
        businessType: "",
        noticeType: "",
        projectAreaCode: "",
        districtCode: "",
        status: "",
        fbDwGuid: "",
        orderType: "orderType1" // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
      },
      loading: false,
      list: [],
      curPage: 1,
      curSdPage: 1,
      pageSize: 20,
      total: 0,
      queryParams: {},
      tableType: 1,
      systemType: "",
      businessType: ""
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["site"]),
    maxPage() {
      return Math.ceil(this.total / this.pageSize);
    },
    showStatus() {
      return (
        this.searchForm.noticeType !==
        INFO_TYPE_OPTIONS.ZBJG[SELECT_OPTION_CONFIG.CODE]
      );
    },
    activeType() {
      return this.businessType || this.systemType || "";
    }
  },
  watch: {
    curPage(val) {
      this.curSdPage = val;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const params = this.$route.query;
    this.queryParams = params;
    this.path = this.$route.path;
    this.searchForm = { ...this.searchForm, ...params };
    this.businessType = params.businessType;
    this.systemType = params.systemType;
    if (this.businessType === "BGGG" || this.businessType === "JGGG") {
      this.systemType = this.businessType;
    }
    this.getBusinessTypeListByType();
    this.getAreaList();
    this.changeActiveMenu();
    if (this.systemType) {
      this.tableType = 2;
      this.getNoticeList("0");
    } else {
      this.getList("0");
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    ...mapActions("permission", ["getActiveMenu"]),
    handleImageError(event) {
      console.log("图片加载失败，使用默认图片");
      event.target.src = require("@/assets/images/home/default.jpg"); // 替换为本地图片路径
    },
    // 获取黑龙江大庆
    getAreaList() {
      dictApi.areaList(this.site.areaCode).then((res) => {
        if (res.code === 0) {
          this.projectAreaList = res.data || [];
          this.projectAreaList.unshift({
            code: "",
            name: "全部"
          });
        }
      });
    },
    // 获取区县
    getDistrictList() {
      dictApi.areaList(this.searchForm.projectAreaCode).then((res) => {
        console.log("地区", res);
        if (res.code === 0) {
          this.districtList = res.data || [];
          this.districtList.unshift({
            code: "",
            name: "全部"
          });
        }
      });
    },
    updateUrlWithoutReload(newPath, newQuery) {
      const url = new URL(window.location.href);
      this.queryParams = { ...newQuery };
      if (newPath) {
        url.pathname = newPath;
      }
      if (newQuery) {
        Object.keys(newQuery).forEach((key) => {
          url.searchParams.set(key, newQuery[key]);
        });
      }
      // 使用 replaceState 更新 URL 而不触发页面刷新
      window.history.replaceState({}, "", url.href);
      this.changeActiveMenu();
    },
    changeActiveMenu() {
      const code =
        this.searchForm.projectType.toLowerCase() || this.$route.params.code;
      // this.getActiveMenu({ params: { ...this.$route.params, code }})
    },
    // 选择筛选条件
    selectFilter(type, value) {
      // console.log(type, value)
      let status = this.searchForm.status || "";
      this.searchForm[type] = value;
      this.businessType = "";
      this.systemType = "";
      switch (type) {
        case "projectAreaCode":
          this.searchForm.districtCode = "";
          this.districtList = [];
          if (this.searchForm.projectAreaCode) {
            this.getDistrictList();
          }
          break;
        case "projectType":
          this.updateUrlWithoutReload(this.$route.path, {
            ...this.queryParams,
            projectType: value
          });
          break;
        case "businessType":
          this.updateUrlWithoutReload(this.$route.path, {
            ...this.queryParams,
            businessType: value
          });
          this.businessType = value;
          this.tableType = 1;
          break;
        case "systemType":
          this.updateUrlWithoutReload(this.$route.path, {
            ...this.queryParams,
            businessType: value
          });
          this.systemType = value;
          this.tableType = 2;
          break;
        case "noticeType":
          if (!this.showStatus) {
            status = "";
            this.searchForm.status = status;
          }
          this.updateUrlWithoutReload(this.$route.path, {
            ...this.queryParams,
            noticeType: value,
            status
          });
          break;
        case "status":
          this.updateUrlWithoutReload(this.$route.path, {
            ...this.queryParams,
            status: value
          });
          break;
        case "unitType":
          this.updateUrlWithoutReload(this.$route.path, {
            ...this.queryParams,
            unitType: value
          });
          break;
      }
      if (type === "systemType") {
        this.getNoticeList("0");
      } else {
        this.getList("0");
      }
    },
    getBusinessTypeListByType() {
      const params = {
        type: this.path.indexOf("gyzcjy") > -1 ? "1" : "2"
      };
      porpertyApi.getBusiness(params).then((res) => {
        if (res.code === 0) {
          const allOption = { code: "", name: "全部" };
          this.projectTypeList = [allOption, ...(res.data || [])];
        }
      });
    },
    // 获取列表
    getList(type) {
      this.loading = true;
      if (type === "0") {
        this.curPage = 1;
      }
      const params = {
        pageNo: this.curPage,
        pageSize: this.tableType === 1 ? 16 : this.pageSize,
        ...this.searchForm,
        xmType: this.path.indexOf("gyzcjy") > -1 ? "1" : "2",
        projectAreaCode:
          this.searchForm.districtCode || this.searchForm.projectAreaCode
      };
      porpertyApi
        .page(params)
        .then((res) => {
          if (res.code === 0) {
            const data = res.data || {};
            this.total = data.total || 0;
            this.list = data.list || [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取公告列表数据
    getNoticeList(type) {
      this.loading = true;
      if (type === "0") {
        this.curPage = 1;
      }
      const params = {
        pageNo: this.curPage,
        pageSize: this.pageSize,
        ...this.searchForm,
        systemType: "CQJY",
        xmType: this.path.indexOf("gyzcjy") > -1 ? "1" : "2",
        noticeType: this.systemType === "BGGG" ? "BGGG" : "CJGG"
      };
      noticeApi
        .page(params)
        .then((res) => {
          if (res.code === 0) {
            const data = res.data || {};
            const list = data.list || [];
            this.total = data.total || 0;
            list.forEach((e) => {
              e.fbstartDate = parseTime(e.fbstartDate, "{y}-{m}-{d}");
            });
            this.list = data.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openUrlInNewTab(url) {
      window.open(url, "_blank");
    },
    headerCellStyle({ columnIndex }) {
      return "background-color: #f9f9f9;padding: 4px 0;";
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "padding: 9px 0;cursor:pointer;";
      // if (columnIndex === 4) {
      //   str += "display: flex;justify-content: center;"
      // }
      if (rowIndex === this.list.length - 1) {
        str += "border: none;";
      }
      return str;
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = Number(val);
      if (this.systemType) {
        this.getNoticeList();
      } else {
        this.getList();
      }
    },
    // 行点击
    rowClick(row) {
      if (row.noticeUrl) {
        window.open(row.noticeUrl, "_blank");
      } else {
        this.$router.push({
          name: "porpertyDetail",
          query: {
            id: this.tableType == 1 ? row.infoId : row.id,
            tableType: this.tableType
          }
        });
      }
    },
    // 排序
    handleSortChange(order) {
      if (order === "orderType2") {
        this.searchForm.orderType =
          this.searchForm.orderType === "orderType2_up"
            ? "orderType2_down"
            : "orderType2_up";
      } else if (order === "orderType3") {
        this.searchForm.orderType =
          this.searchForm.orderType === "orderType3_up"
            ? "orderType3_down"
            : "orderType3_up";
      } else if (order.order) {
        this.searchForm.orderType =
          order.order == "descending"
            ? "endTime_down"
            : order.order == "ascending"
              ? "endTime_up"
              : "orderType1";
      } else {
        this.searchForm.orderType = "orderType1";
      }
      this.getList("0");
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 30px;
}
.filter-content {
  padding: 0 10px;
  background-color: #fff;
  border: 1px solid #ddd;
  .filter-list {
    padding: 20px 10px;
    .filter-item {
      .filter-label {
        width: 90px;
        min-width: 90px;
        text-align: right;
        color: #666;
        font-size: 14px;
      }
      .filter-option-list {
        margin-left: 20px;
        flex-wrap: wrap;
        .filter-option {
          height: 24px;
          line-height: 22px;
          padding: 0 10px;
          border: 1px solid #fff;
          border-radius: 24px;
          margin: 0 10px 10px 0;
          cursor: pointer;
          &:hover {
            color: $--color-primary;
            border-color: $--color-primary;
          }
        }
        .active {
          color: $--color-primary;
          border-color: $--color-primary;
        }
      }
    }
    .filter-item + .filter-item {
      margin-top: 10px;
    }
  }
  .filter-total {
    border-top: 1px dashed #ddd;
    height: 50px;
  }
}
.list-content {
  margin-top: 20px;
  border: 1px solid #ddd;
}
.project-table {
  &::before {
    height: 0;
  }
  .table-btn {
    display: inline-block;
    width: 70px;
    height: 24px;
    color: #fff;
    text-align: center;
  }
}
.table-pagination {
  margin-top: 35px;
  ::v-deep {
    .el-pager li {
      width: 34px;
      height: 34px;
      line-height: 34px;
      background-color: #fff;
      color: #666;
      border: 1px solid #ddd;
    }
    .btn-prev,
    .btn-next {
      width: 70px;
      height: 34px;
      background-color: #fff;
      color: #666;
      border: 1px solid #ddd;
    }
    .btn-next {
      margin-right: 10px;
    }
  }
  .page-input {
    width: 60px;
    margin-left: 5px;
    ::v-deep .el-input__inner {
      height: 33px;
      padding: 0 5px;
    }
  }
  .jump-btn {
    width: 50px;
    height: 33px;
    background: $--color-primary;
    border-radius: 0;
    margin-left: 10px;
    color: #fff;
  }
}
.select-list-bot {
  padding: 12px 0 0 0;
}
.select-list-bot .boxTop {
  position: relative;
  z-index: 25;
  display: inline-block;
}
.select-list-bot .boxTop input {
  width: 50px;
  height: 25px;
  padding: 0px 5px;
  border: 1px solid #e1e1e1;
  background: #fff;
  font-family: "microsoft yahei";
  outline: none;
  float: left;
}
.select-list-bot .boxTop input.ip1 {
  margin-right: 2px;
}
.select-list-bot .boxTop input.ip2 {
  margin-left: 2px;
}
.select-list-bot .boxTop .money-btn {
  border: 0px;
  margin: 0 0 0 10px;
}
.select-list-bot a {
  color: #333;
  cursor: pointer;
}
.select-list-bot a:hover {
  color: #dd342c;
}

.select-list-bot .location {
  padding-right: 10px;
  line-height: 25px;
  height: 25px;
  position: relative;
  z-index: 44;
  cursor: pointer;
  border: 0px;
}
.select-list-bot .location:hover {
  border: 0px;
}
.select-list-bot .location i {
  background: url(@/assets/images/home/triangle-down.png) no-repeat;
  display: inline-block;
  width: 7px;
  height: 4px;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
  -webkit-transition: -webkit-transform 0.2s ease-out;
  -moz-transition: -moz-transform 0.2s ease-out;
  -o-transition: -o-transform 0.2s ease-out;
  -ms-transition: -ms-transform 0.2s ease-out;
}
.select-list-bot .location:hover i {
  transform: rotateZ(180deg);
  -webkit-transform: rotateZ(180deg);
  -moz-transform: rotateZ(180deg);
  -o-transform: rotateZ(180deg);
  -ms-transform: rotateZ(180deg);
}
.select-list-bot .location.curr i {
  transform: rotateZ(180deg);
  -webkit-transform: rotateZ(180deg);
  -moz-transform: rotateZ(180deg);
  -o-transform: rotateZ(180deg);
  -ms-transform: rotateZ(180deg);
}
.select-list-bot .location .icon-jiage {
  background: url(@/assets/images/home/js_ico.png) no-repeat -5px -5px;
  display: inline-block;
  line-height: 10px;
  vertical-align: middle;
  margin-left: 4px;
  width: 8px;
  height: 13px;
}
.select-list-bot .location .icon-jiage2 {
  background: url(@/assets/images/home/js_ico.png) no-repeat -60px -5px;
  display: inline-block;
  line-height: 10px;
  vertical-align: middle;
  margin-left: 4px;
  width: 8px;
  height: 13px;
}
.select-list-bot .location.up .icon-jiage {
  background-position: -20px -5px;
}
.select-list-bot .location.down .icon-jiage {
  background-position: -33px -5px;
}
.select-list-bot .location.curr .icon-jiage2 {
  background-position: -83px -5px;
}
</style>
